import React, { useState, useEffect, useRef, useMemo } from "react";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import {
  Button,
  Box,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  FormControlLabel,
  Switch,
  Typography,
  IconButton,
  ListItemSecondaryAction
} from '@mui/material';
import  {
  PictureAsPdf,
  Image,
} from '@mui/icons-material';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';

import { FormInputDropdown, FormInputText, FormInputDate } from "../../form";
import { DialogTitleClose, PaperComponent } from "../../dialog";

import * as gfileStore from "../../../store/gfiles";
import SecurityUtil from '../../../utils/SecurityUtils';

// 한국어 로케일 설정
dayjs.locale('ko');
const defaultValues = {
  title: "",
  startDate: "",
  endDate: "",
  popupYn: false,
  content: "",
};

const NoticeViewDialog = ({ 
  open,
  setOpen,
  selectedRow,
 }) => {

  const { handleSubmit, reset, control, setValue } = useForm({ defaultValues: defaultValues });


  const [attachFiles, setAttachFiles] = useState([]);

  const sanitizedContent = useMemo(() => {
    return SecurityUtil.sanitizeHtml(selectedRow?.content);
  }, [selectedRow?.content]);

  const sessionUser = useSelector(state => state.session.sessionUser);

  const initDialog = () => {
    console.log("selectedRow => ", selectedRow);
    if (selectedRow) {
      for (const [item, value] of Object.entries(defaultValues)) {
        setValue(item, selectedRow[item] || value);
      }
    }
  }

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      initDialog();

      if (selectedRow && selectedRow.attachments && Array.isArray(selectedRow.attachments)) {
        setAttachFiles(selectedRow?.attachments?.map(file => ({ ...file, downloading: false })))
      } else {
        setAttachFiles([]);
      }
    }
  }, [open, selectedRow]);

  const handleClickDownload = async (e, idx) => {
    e.stopPropagation();

    const { seq, refType, filename } = attachFiles[idx];
    
    const newAttachFiles = attachFiles.map((file, i) => (i === idx ? { ...file, downloading: true } : file));

    setAttachFiles(newAttachFiles);

    const res = await gfileStore.downloadFile(seq, refType);
    const blob = await res.blob(); // res.blob는 promise를 리턴함???
    
    // 2. Create blob link to download
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    // 3. Append to html page
    document.body.appendChild(link);
    // 4. Force download
    link.click();
    // 5. Clean up and remove the link
    link.parentNode.removeChild(link);

    setTimeout(() => {
      setAttachFiles(newAttachFiles.map((file, i) => (i === idx ? { ...file, downloading: false } : file)));
    }, 1000);
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose} 
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      maxWidth="md"
      sx={{
        '& .MuiDialog-paper': {
          width: '580px',
          height: '650px',
        },
      }}
    >
      <DialogTitleClose
        id="draggable-dialog-title"
        onClose={handleClose}
        style={{ cursor: 'move' }}
      >
        {selectedRow.title}
      </DialogTitleClose>
      <DialogContent>
        <Grid container spacing={2}>
          { sessionUser.type === 'ADMIN' && (
            <>
              <Grid item xs={6}>
                <FormInputDate
                  name={"startDate"}
                  control={control}
                  label={"공지 시작일"}
                  inputHeight={38}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={6}>
                <FormInputDate
                  name={"endDate"}
                  control={control}
                  label={"공지 종료일"}
                  inputHeight={38}
                  disabled={true}
                  />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={selectedRow.popupYn}
                      disabled={true}
                    />
                  }
                  label="공지 팝업여부"
                />
              </Grid>
            </>
          )}
          <Grid item xs={12}>
          <Box>
              {
                selectedRow.attachments && selectedRow.attachments.length > 0 
                                        && selectedRow.attachments.map((file, index) => {
                  const { filename } = file;
                  const pos = filename.lastIndexOf(".");
                  let ext = "";
                  if (pos > -1) {
                    ext = filename.substring(pos+1);
                  }

                  return (
                    <ListItem disablePadding>
                      <Tooltip title={"다운로드"}>
                      <ListItemButton onClick={(e) => handleClickDownload(e, index)}>
                        <ListItemIcon>
                          { ext.toLowerCase() === 'pdf' ? <PictureAsPdf /> : <Image /> }
                        </ListItemIcon>
                        <ListItemText primary={filename} />
                      </ListItemButton>
                      </Tooltip>
                    </ListItem>
                  )
                })
              } 
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box 
              component="div"
              sx={{ 
               // border: '1px solid #ddd', 
                //borderRadius: 1, 
                minHeight: '300px',
                whiteSpace: 'pre-wrap', // 연속된 공백, 줄바꿈 을 보존
                '& p': {
                  margin: 0,
                  marginBlockStart: 0,
                  marginBlockEnd: 0,
                  marginInlineStart: 0,
                  marginInlineEnd: 0,
                  display: 'block'
                }
              }}
              dangerouslySetInnerHTML={{ __html: sanitizedContent}}
            />
          </Grid> 
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{"닫기"}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default NoticeViewDialog;